import { render, staticRenderFns } from "./SupplierOrderSubtitle.vue?vue&type=template&id=1d9e1c2d&"
import script from "./SupplierOrderSubtitle.vue?vue&type=script&lang=ts&"
export * from "./SupplierOrderSubtitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports